import { combineReducers } from '@reduxjs/toolkit';
import assetsSlice from './domains/assets/slice';
import geoplacesSlice from './slice';

const domainReducers = combineReducers({
  assets: assetsSlice.reducer,
});

export default combineReducers({
  entity: geoplacesSlice.reducer,
  domains: domainReducers,
});
